import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ImageRadioButton, ImageRadioButtonSize, Row, Column, Carousel, CarouselVariant, SliderNavVariant, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { generateSwatchFromProductColorVariation } from '../../util/SwatchUtil';
const SLIDE_WIDTH = 34;
const SLIDES_TO_SCROLL_CORRECTION = 3;
export const PromoBasketPopupColorSwatches = ({ colors, productCode, selectedColorId, setProductColor, }) => {
    const { productImageConfig } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [swiper, updateSwiper] = useState(null);
    const isMobile = useMediaQueryMatchesOnMobile();
    const selectedProductColor = colors.find((colorVariation) => colorVariation.colorId === selectedColorId);
    const renderSlide = useCallback((colour, index) => (_jsx("div", { children: _jsx(ImageRadioButton, { id: `promo-basket-popup-${productCode}-${colour.colourId}`, name: `color_swatch_${productCode}`, value: colour.colourId.toString(), checked: colour.colourId === (selectedProductColor === null || selectedProductColor === void 0 ? void 0 : selectedProductColor.colorId), imageUrl: colour.swatch, imageLazyLoad: true, title: colour.color, onChange: () => setProductColor(colour.colourId), size: isMobile ? null : ImageRadioButtonSize.LARGE }) }, `color_swatch_${colour.colourId}_${index}`)), [colors, selectedProductColor, isMobile]);
    useEffect(() => {
        if (swiper !== null) {
            swiper.update();
        }
    }, [colors, selectedProductColor, isMobile]);
    const calculateSlidesToScroll = (slidesToScroll, swatches) => swatches && swatches.length - 1 === slidesToScroll ? slidesToScroll : slidesToScroll - SLIDES_TO_SCROLL_CORRECTION;
    const colorSwatches = colors.map((productColor) => generateSwatchFromProductColorVariation(productColor, selectedColorId, productCode, productImageConfig.cdnDomains));
    function onSwiperInit() {
        const maxSlides = Math.floor(this.width / SLIDE_WIDTH);
        this.params.slidesPerView = maxSlides;
        this.navigation.update();
        this.update();
    }
    function onSwiperResize() {
        const maxSlides = Math.floor(this.width / SLIDE_WIDTH);
        if (this.params.slidesPerView !== maxSlides) {
            this.params.slidesPerView = maxSlides;
            this.navigation.update();
            this.update();
        }
    }
    const colorSwatchesSlideConfig = {
        variant: isMobile ? CarouselVariant.SWATCHES : CarouselVariant.SWATCHES_LARGE,
        arrowsConfig: {
            variant: isMobile ? SliderNavVariant.SWATCHES : SliderNavVariant.SWATCHES_LARGE,
        },
        showPagination: false,
        configurationOverrides: {
            getSwiper: updateSwiper,
            preventClicks: false,
            watchOverflow: true,
            slidesPerGroup: calculateSlidesToScroll(5, colorSwatches),
            spaceBetween: 0,
            shouldSwiperUpdate: true,
            noSwiping: false,
            allowTouchMove: false,
            on: {
                init: onSwiperInit,
                resize: onSwiperResize,
            },
        },
    };
    if (!colorSwatches.length && !selectedColorId)
        return null;
    return (_jsxs(Box, { paddingBlockEnd: { base: '4', md: '6' }, children: [_jsx(Row, { parent: true, children: _jsxs(Column, { gutter: false, children: [_jsxs(TextAlpha, { variant: "bodyS", as: "span", strong: true, children: [t('product:pdp.color'), ":", ' '] }), _jsx(TextAlpha, { variant: "bodyS", as: "span", testId: "color_name", children: selectedProductColor === null || selectedProductColor === void 0 ? void 0 : selectedProductColor.translations.description })] }) }), (colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.length) > 1 && (_jsx(Box, { paddingBlockStart: { base: '2', md: '3' }, children: _jsx(Carousel, Object.assign({}, colorSwatchesSlideConfig, { children: colorSwatches.map((image, index) => renderSlide(image, index)) })) }))] }));
};
